// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// TODO. UGLY. It is used only in chart so far.
// Use already defined StopOrderEdit, StopLimitOrderEdit, LimitOrderEdit instances.
// Supports different stop/limit, buy/sell bound order pairs.
// TODO. Doesn't support StopLimit.
// NOTE:
// stopPrice - first order's price.
import { OperationType } from '@shared/utils/Trading/OperationType';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { OCOOrderEdit } from './OCOOrderEdit';
// limitPrice - second order's price.
export class OCOCustomOrdersEdit extends OCOOrderEdit {
    constructor(data) {
        super(data);
        this.firstOrderType = null;
        this.secondOrderType = null;
        this.firstOrderTif = null;
        this.secondOrderTif = null;
        this.firstOrderSide = null;
        this.secondOrderSide = null;
    }
    setOrdersTypes(firstOrderType, secondOrderType) {
        this.firstOrderType = firstOrderType;
        this.secondOrderType = secondOrderType;
    }
    setOrdersTifs(firstOrderTif, secondOrderTif) {
        this.firstOrderTif = firstOrderTif;
        this.secondOrderTif = secondOrderTif;
    }
    setOrdersSides(firstOrderSide, secondOrderSide) {
        this.firstOrderSide = firstOrderSide;
        this.secondOrderSide = secondOrderSide;
    }
    setOrdersPrices(firstOrderPrice, secondOrderPrice) {
        this.stopPrice = secondOrderPrice;
        this.limitPrice = firstOrderPrice;
        // TODO. Validate.... Whatever. Details are at the top of OCOCustomOrdersEdit.
    }
    getDataForRequest() {
        const data = super.getDataForRequest();
        data.ocoCustomOrdersData = {
            firstOrderType: this.firstOrderType,
            secondOrderType: this.secondOrderType,
            firstOrderTif: this.firstOrderTif,
            secondOrderTif: this.secondOrderTif,
            firstOrderSide: this.firstOrderSide,
            secondOrderSide: this.secondOrderSide,
            firstOrderLimitPriceForStopLimit: this.firstOrderType === OrderType.StopLimit
                ? this.getLimitPriceWithDefaultOffset(this.limitPrice, this.firstOrderSide === OperationType.Buy)
                : null,
            secondOrderLimitPriceForStopLimit: this.secondOrderType === OrderType.StopLimit
                ? this.getLimitPriceWithDefaultOffset(this.stopPrice, this.secondOrderSide === OperationType.Buy)
                : null
        };
        return data;
    }
}
